import angular from 'angular';
import CSMCommonWeb from 'csm-common-web';
import vendorListDialogTemplate from '../templates/VendorListDialog.template.html'

export default angular
    .module('vendorsAdmin.dialogs.VendorListDialog', [CSMCommonWeb])
    .service('VendorListDialog', Service)
    .name;

/*****************************************************************************
 * Service: VendorListDialog
 *
 * Utility to show a dialog to print vendors
 *****************************************************************************/
/* @ngInject */ function Service($uibModal) {
  /***************************************************************************
   * show */
  /**
   * Show the modal dialog for printing vendors.
   *
   * @param  vendorsList  List of vendors to choose from.
   * @return              Promise that resolves when the modal dialog is closed.
   ***************************************************************************/
  this.show = function (vendorsList) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: VendorListDialogController,
      resolve: {
        vendorsList: function () {
          return vendorsList;
        }
      },
      size: 'md',
      template: vendorListDialogTemplate
    }).result;
  };
}

/** Dialog Controller. */
/* @ngInject */ function VendorListDialogController($scope, vendorsList) {
  /***************************************************************************
   * Properties
   ***************************************************************************/
  $scope.data = {
    vendor: null,
    showTax: true,
    showAddress: true,
    showPhone: true,
    showContact: true,
    showEmail: true,
    sortName: true
  };

  $scope.reportFormat = 'PDF';
  $scope.dpVendors = [{ name: '-- All --', id: 0 }].concat(vendorsList);
  $scope.data.vendor = $scope.dpVendors[0];

  /***************************************************************************
   * generateList */
  /**
   * Checks inputs and generates report
   ***************************************************************************/
  $scope.generateList = function () {
    var pageURL =
      'CustomVendorList.aspx?rt=' +
      $scope.reportFormat +
      '&vid=' +
      $scope.data.vendor.id +
      '&st=' +
      $scope.data.showTax +
      '&sa=' +
      $scope.data.showAddress +
      '&sp=' +
      $scope.data.showPhone +
      '&sc=' +
      $scope.data.showContact +
      '&se=' +
      $scope.data.showEmail +
      '&sn=' +
      $scope.data.sortName;

    window.open(pageURL);
  };
}
